module.exports = __webpack_public_path__ + "img/thermo-king-logo.09a30dd5.png";